<template>
  <div class="rounded-lg relative md:rounded-[32px]">
    <ExampleImage
      v-if="withExampleImage"
      class="text-static-light-hi caption-bold absolute left-24 top-24"
      :with-icon="false"
    />
    <RevIllustration
      alt=""
      class="rounded-lg block aspect-[3/2] h-[218px] w-full max-w-[498px] object-cover md:h-[498px] md:w-[498px] md:min-w-[337px] md:rounded-[32px]"
      :class="`object-[${position}]`"
      :height="498"
      :src
      :width="498"
    />
  </div>
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'

import ExampleImage from '~/scopes/product-core/components/presentationals/ExampleImage/ExampleImage.vue'

defineProps<{
  src: string
  position: string
  withExampleImage?: boolean
}>()
</script>
